import API from "01Data/02User/API";
import { UserKind } from "01Data/Account";
import { AppContext } from "01Data/AppData";
import { BuildingInfo, IFMapImage } from "01Data/DataTypes";
import PageTemplate from "04UserPages/00PageTemplate/PageTemplate";
import {
  IFDlgCaller,
  RegisterFormBuilding,
} from "04UserPages/99Parts/CommonDlgs";
import { MapReader } from "97Parts/MapReader";
import { NoteText } from "97Parts/Styles";
import { useModel, useSignal } from "99Tools/useModel";
import { CheckKizaiID } from "99Tools/utils";
import { AddCircle } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  styled,
} from "@mui/material";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

const ApplyButton = styled(LoadingButton)(({ theme }) => ({
  margin: theme.spacing(3, 0, 2),
}));

const ErrorText = styled("div")(({ theme }) => ({
  color: "#f00",
}));

const LocationSelector = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (val: any) => void;
}) => {
  const d = useContext(AppContext).dataUser.locations;
  const menu = d.locations
    .sort((a, b) => a.BuildingName.localeCompare(b.BuildingName))
    .map((item: BuildingInfo) => (
      <MenuItem value={item.BuildingId} key={item.BuildingId}>
        {item.BuildingName}
      </MenuItem>
    ));
  return (
    <FormControl fullWidth variant="outlined" sx={{ marginTop: "20px" }}>
      <InputLabel id="dlg_building_label">建物</InputLabel>
      <Select
        labelId="dlg_building_label"
        id="location"
        value={value}
        label="建物"
        onChange={onChange}
      >
        {menu}
      </Select>
    </FormControl>
  );
};

const FormPico3 = () => {
  const d = useContext(AppContext).dataUser.locations;
  const p = d.pageRegisterDevice;
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [locationName, setLocationName] = useState("");
  const [message, setMesasge] = useState("");
  const [bShowRegisterDlg, setShowRegisterDlg] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileExtension, setFileExtension] = useState("");
  const [data, setData] = useState("");
  const redraw = useSignal();

  class ImageData implements IFMapImage {
    setFileName(name: string): void {
      setFileName(name);
    }
    getFileName(): string {
      return fileName;
    }
    setFileExtension(extension: string): void {
      setFileExtension(extension);
    }
    setData(data: string): void {
      setData(data);
    }
    setError(err: any, message: string): void {
      setMesasge(message);
      console.log(err);
    }
    clear() {
      setFileName("");
      setFileExtension("");
      setData("");
      setMesasge("");
    }
  }

  const handleChangeName = (e: any) => {
    setName(e.target.value);
  };

  const handleChangeLocationName = (e: any) => {
    setLocationName(e.target.value);
  };

  const handleChangeLocationId = (val: any) => {
    const building = d.locations.find(
      (building: BuildingInfo) => building.BuildingId === val.target.value
    );
    if (building) {
      p.building = building;
      redraw();
    }
  };

  const handleRegister = () => {
    if (name === "") {
      setMesasge("Pico3名を入力してください。");
      return;
    }
    if (p.building.BuildingId === "") {
      setMesasge("建物を選択してください。");
      return;
    }
    d.ResigterPico3(
      p.deviceId,
      name,
      p.building.BuildingId,
      locationName,
      data,
      fileExtension
    )
      .then(() => {
        navigate(`/devices?building=${p.building.BuildingId}`);
      })
      .catch((err: Error) => {
        if (err.message === "すでに存在") {
          setMesasge("デバイスはすでに登録されています。");
        } else {
          setMesasge("登録が失敗しました。管理者にご連絡ください。");
        }
        console.log("デバイス登録失敗");
        console.error(err);
      });
  };

  const caller: IFDlgCaller = {
    bShow: () => bShowRegisterDlg,
    close: () => setShowRegisterDlg(false),
    redraw: () => p.changed(),
    action: async (data: any) => {
      await d.RegisterLocation(
        data.name,
        data.syokenId,
        data.address,
        data.image,
        data.imageExtension
      );
      await d.GetLocationData();
      const building = d.locations.find(
        (building: BuildingInfo) => building.BuildingName === data.name
      );
      if (building) {
        p.building = building;
        p.changed();
      }
    },
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", padding: "4vw" }}>
      <FormControl fullWidth>
        <NoteText>付帯情報を入力し、「登録」ボタンを押してください</NoteText>
        <LocationSelector
          value={p.building.BuildingId}
          onChange={handleChangeLocationId}
        />
        <AddBuildingButton open={() => setShowRegisterDlg(true)} />
        <TextField
          variant="filled"
          margin="normal"
          fullWidth
          id="kizaiId"
          label="機材ID"
          name="kizaiId"
          disabled
          value={p.deviceId}
        />
        <TextField
          required
          variant="filled"
          margin="normal"
          fullWidth
          id="name"
          label="Pico3名"
          name="name"
          onChange={handleChangeName}
          inputProps={{ maxLength: 128 }}
          value={name}
        />
        <TextField
          variant="filled"
          margin="normal"
          fullWidth
          id="locationName"
          label="設置場所"
          name="name"
          onChange={handleChangeLocationName}
          inputProps={{ maxLength: 128 }}
          value={locationName}
        />
        <MapReader entity={new ImageData()} redraw={() => {}} />
        <ApplyButton
          variant="contained"
          color="primary"
          onClick={handleRegister}
        >
          登録
        </ApplyButton>
        {message !== "" ? <ErrorText>{message}</ErrorText> : null}
      </FormControl>
      <RegisterFormBuilding caller={caller} />
    </Paper>
  );
};

const FormLTE = () => {
  const d = useContext(AppContext).dataUser.locations;
  const p = d.pageRegisterDevice;
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [locationName, setLocationName] = useState("");
  const [message, setMesasge] = useState("");
  const [bShowRegisterDlg, setShowRegisterDlg] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileExtension, setFileExtension] = useState("");
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const redraw = useSignal();

  class ImageData implements IFMapImage {
    setFileName(name: string): void {
      setFileName(name);
    }
    getFileName(): string {
      return fileName;
    }
    setFileExtension(extension: string): void {
      setFileExtension(extension);
    }
    setData(data: string): void {
      setData(data);
    }
    setError(err: any, message: string): void {
      setMesasge(message);
      console.log(err);
    }
    clear() {
      setFileName("");
      setFileExtension("");
      setData("");
      setMesasge("");
    }
  }

  const handleChangeName = (e: any) => {
    setName(e.target.value);
  };

  const handleChangeLocation = (e: any) => {
    setLocationName(e.target.value);
  };

  const handleChangeBuildingId = (val: any) => {
    const building = d.locations.find(
      (building: BuildingInfo) => building.BuildingId === val.target.value
    );
    if (building) {
      p.building = building;
      redraw();
    }
  };

  const handleRegister = () => {
    if (name === "") {
      setMesasge("漏水みはり番名を入力してください。");
      return;
    }
    if (p.building.BuildingId === "") {
      setMesasge("建物を選択してください。");
      return;
    }
    setLoading(true);
    d.ResigterSensor(
      p.deviceId,
      name.replaceAll(`"`, `\\"`),
      p.building.BuildingId,
      locationName.replaceAll(`"`, `\\"`),
      data,
      fileExtension
    )
      .then(() => {
        navigate(`/devices?building=${p.building.BuildingId}`);
      })
      .catch((err: Error) => {
        if (err.message === "すでに存在") {
          setMesasge("デバイスはすでに登録されています。");
        } else if (err.message === "SIMが存在しない") {
          setMesasge(
            "指定された機材IDは旭光電機のSoracomアカウントに登録されていません"
          );
        } else if (err.message === "チェックサム不正") {
          setMesasge("機材IDが不正です。");
        } else if ((err as Error).message === "SIM有効期限未設定") {
          setMesasge("SIMの有効期限が未設定です。");
        } else {
          setMesasge("デバイス登録に失敗しました。");
        }
        console.log("デバイス登録失敗");
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    API.GetSensors().then((res) => {
      const sensor = res.find((s: any) => s.SensorId === p.deviceId);
      if (sensor) {
        setLocationName(sensor.LocationName);
        setName(sensor.SensorName);
        const building = d.locations.find(
          (building: BuildingInfo) => building.BuildingId === sensor.BuildingId
        );
        if (building) {
          p.building = building;
          p.changed();
        }
      }
    });
  }, [d, p]);

  const caller: IFDlgCaller = {
    bShow: () => bShowRegisterDlg,
    close: () => setShowRegisterDlg(false),
    redraw: () => p.changed(),
    action: async (data: any) => {
      await d.RegisterLocation(
        data.name,
        data.syokenId,
        data.address,
        data.image,
        data.imageExtension
      );
      await d.GetLocationData();
      const building = d.locations.find(
        (building: BuildingInfo) => building.BuildingName === data.name
      );
      if (building) {
        p.building = building;
        p.changed();
      }
    },
  };
  return (
    <Paper sx={{ width: "100%", overflow: "hidden", padding: "4vw" }}>
      <FormControl fullWidth>
        <NoteText>付帯情報を入力し、「登録」ボタンを押してください</NoteText>
        <LocationSelector
          value={p.building.BuildingId}
          onChange={handleChangeBuildingId}
        />
        <AddBuildingButton open={() => setShowRegisterDlg(true)} />
        <TextField
          variant="filled"
          margin="normal"
          fullWidth
          id="kizaiId"
          label="機材ID"
          name="kizaiId"
          disabled
          value={p.deviceId}
        />
        <TextField
          variant="filled"
          margin="normal"
          fullWidth
          required
          id="name"
          label="漏水みはり番名"
          name="name"
          onChange={handleChangeName}
          inputProps={{ maxLength: 128 }}
          value={name}
        />
        <TextField
          variant="filled"
          margin="normal"
          fullWidth
          id="location"
          label="設置場所名"
          name="location"
          onChange={handleChangeLocation}
          inputProps={{ maxLength: 128 }}
          value={locationName}
        />
        <MapReader entity={new ImageData()} redraw={() => {}} />
        <ApplyButton
          variant="contained"
          color="primary"
          onClick={handleRegister}
          loading={loading}
        >
          登録
        </ApplyButton>
        {message !== "" ? <ErrorText>{message}</ErrorText> : null}
      </FormControl>
      <RegisterFormBuilding caller={caller} />
    </Paper>
  );
};

const AddBuildingButton = ({ open }: { open: () => void }) => {
  const user = useContext(AppContext).account;
  if (user.IsUserManager() || user.IsUserViewer()) {
    // 権限チェック
    return null;
  }

  return (
    <div style={{ display: "flex", justifyContent: "end", margin: "10px 0" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Button
          component="label"
          variant="contained"
          startIcon={<AddCircle />}
          onClick={open}
        >
          建物追加
        </Button>
      </div>
    </div>
  );
};

const DevicesRegisterContents = () => {
  const d = useContext(AppContext).dataUser.locations;
  const p = d.pageRegisterDevice;

  if (p.kind === "pico3") {
    return <FormPico3 />;
  }
  if (p.kind === "lte") {
    return <FormLTE />;
  }
  return <Link to={"/buildings"}>建物一覧へ</Link>;
};

const DeviceRegisterPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const a = useContext(AppContext).account;
  const d = useContext(AppContext).dataUser.locations;
  const p = d.pageRegisterDevice;
  useModel(p);
  const [title, setTitle] = useState("");

  useLayoutEffect(() => {
    // QRコードでアクセス時の権限チェック
    // (デバイス追加ボタンからの導線はない)
    a.IsLogin((kind: UserKind) => {
      switch (kind) {
        case "administrator":
        case "sub_admin":
        case "manager":
          return true;
        case "user":
          return false;
        default:
          return false;
      }
    }).catch(() => {
      navigate("/top/");
    });
  }, [a, navigate]);

  useEffect(() => {
    const id = searchParams.getAll("id");
    if (id.length === 0) {
      navigate("/buidings/");
    }
    const kind = CheckKizaiID(id[0]);
    switch (kind) {
      case "pico3":
        p.kind = "pico3";
        setTitle("Pico3 登録");
        break;
      case "lte":
      case "subgiga":
        p.kind = "lte";
        setTitle("漏水みはり番登録");
        break;
      case "error":
        p.kind = "error";
        setTitle("Pico3からの登録をお願いします。");
        break;
      default:
        p.kind = "init";
        setTitle("");
        break;
    }
    p.deviceId = id[0];
    d.GetLocationData()
      .then(() => {
        const location = searchParams.getAll("building");
        if (location.length !== 0) {
          // webから
          const index = d.SearchLocation(location[0]);
          if (0 <= index) {
            p.building = d.locations[index];
            p.changed();
          } else {
            navigate("/buildings/");
          }
        } else {
          // QRコードから
          p.changed();
        }
      })
      .catch((err: any) => {
        console.log("建物一覧取得処理失敗");
        console.error(err);
      });
  }, [searchParams, navigate, d, p]);

  return (
    <PageTemplate title={title}>
      <DevicesRegisterContents />
    </PageTemplate>
  );
};

export default DeviceRegisterPage;
